module.exports = __webpack_public_path__ + "static/img/left-num-row-6.e602595c.webp";